import { Redirect } from 'react-router-dom'

import InDepthAnalysisCreateEdit from '../Components/InDepthAnalysis/InDepthAnalysisCreateEdit/InDepthAnalysisCreateEdit'
import ActivityCalendar from '../pages/Activities/ActivityCalendar'
import AgencyEdit from '../pages/Administration/Agency/AgencyEdit/AgencyEdit'
import AgencyView from '../pages/Administration/Agency/AgencyView/AgencyView'
import GdprExport from '../pages/Administration/GdprExport/GdprExport'
import OfficeCreateEdit from '../pages/Administration/Office/OfficeCreateEdit/OfficeCreateEdit'
import OfficeList from '../pages/Administration/Office/OfficeList/OfficeList'
import UserEdit from '../pages/Administration/User/UserEdit/UserEdit'
import UsersList from '../pages/Administration/User/UsersList/UsersList'
import ForgotPassword from '../pages/Authentication/ForgotPassword'
import Impersonation from '../pages/Authentication/Impersonation'
import Login from '../pages/Authentication/Login'
import Register from '../pages/Authentication/Register'
import ResetPassword from '../pages/Authentication/ResetPassword'
import CompanyCreate from '../pages/Companies/CompanyCreate'
import CompanyEdit from '../pages/Companies/CompanyEdit'
import CompanyList from '../pages/Companies/CompanyList/CompanyList'
import CompanyView from '../pages/Companies/CompanyView'
import ContactCreate from '../pages/Contacts/ContactCreate'
import ContactEdit from '../pages/Contacts/ContactEdit'
import ContactList from '../pages/Contacts/ContactList/ContactList'
import ContactView from '../pages/Contacts/ContactView/ContactView'
import EvidenceDiaryEdit from '../pages/Diaries/EvidenceDiary/Edit/EvidenceDiaryEdit'
import EvidenceDiaryList from '../pages/Diaries/EvidenceDiary/List/EvidenceDiaryList'
import IntermediaryDiaryEdit from '../pages/Diaries/IntermediaryDiary/Edit/IntermediaryDiaryEdit'
import IntermediaryDiaryList from '../pages/Diaries/IntermediaryDiary/List/IntermediaryDiaryList'
import DocumentList from '../pages/Documents/DocumentList'
import ProjectCreate from '../pages/Projects/ProjectCreate'
import ProjectEdit from '../pages/Projects/ProjectEdit'
import ProjectList from '../pages/Projects/ProjectList/ProjectList'
import ProjectView from '../pages/Projects/ProjectView/ProjectView'
import PropertyCreate from '../pages/Properties/PropertyCreate/PropertyCreate'
import PropertyEdit from '../pages/Properties/PropertyEdit'
import PropertyList from '../pages/Properties/PropertyList/PropertyList'
import PropertyView from '../pages/Properties/PropertyView/PropertyView'
import ReportList from '../pages/Reports/ReportList/ReportList'

const authProtectedRoutes = [
    { path: '/activities', component: ActivityCalendar },

    { path: '/documents', component: DocumentList },
    // { path: '/documents/edit', component: DocumentEdit },

    // projects
    { path: '/projects', component: ProjectList },
    { path: '/projects/new', exact: true, component: ProjectCreate },
    { path: '/projects/:id(\\d+)', exact: true, component: ProjectView },
    { path: '/projects/:id/edit', component: ProjectEdit },

    // contacts route
    { path: '/contacts', component: ContactList },
    { path: '/contacts/new', exact: true, component: ContactCreate },
    { path: '/contacts/:id(\\d+)', exact: true, component: ContactView },
    { path: '/contacts/:id/edit', component: ContactEdit },
    { path: '/contacts/:id/indepthanalysis/createEdit', component: InDepthAnalysisCreateEdit },

    // companies
    { path: '/companies', component: CompanyList },
    { path: '/companies/new', component: CompanyCreate },
    { path: '/companies/:id(\\d+)', component: CompanyView },
    { path: '/companies/:id/edit', component: CompanyEdit },
    { path: '/companies/:id/indepthanalysis/createEdit', component: InDepthAnalysisCreateEdit },

    // real estates
    { path: '/properties', component: PropertyList },
    { path: '/properties/new', component: PropertyCreate },
    { path: '/properties/:id(\\d+)', component: PropertyView },
    { path: '/properties/:id/edit', component: PropertyEdit },

    //intermediary diary
    { path: '/intermediary-diary', component: IntermediaryDiaryList },
    { path: '/intermediary-diary/:id/edit', component: IntermediaryDiaryEdit },

    // evidence diary
    { path: '/evidence-diary', component: EvidenceDiaryList },
    { path: '/evidence-diary/:id/edit', component: EvidenceDiaryEdit },

    // reports
    {
        path: '/reports/:reportType?',
        component: ReportList,
    },
]

const adminProtectedRoutes = [
    // Authentication Page
    { path: '/admin', exact: true, component: () => <Redirect to="/admin/agency" /> },
    { path: '/admin/agency', component: AgencyView },
    { path: '/admin/agency/:id/edit', component: AgencyEdit },
    { path: '/admin/office', component: OfficeList },
    { path: '/admin/office/:id/edit', component: OfficeCreateEdit },
    { path: '/admin/office/create', component: OfficeCreateEdit },
    { path: '/admin/user', component: UsersList },
    { path: '/admin/user/:id/edit', component: UserEdit },
    // TODO: temporary disabled until download is solved
    // { path: '/admin/export', component: GdprExport },
]

const publicRoutes = [
    // Authentication Page
    { path: '/login', component: Login },
    { path: '/forgot-password', component: ForgotPassword },
    { path: '/password-recovery', component: ResetPassword },
    { path: '/register', component: Register },
    { path: '/impersonation', component: Impersonation },
]

export { adminProtectedRoutes, authProtectedRoutes, publicRoutes }
